export enum CONTRACT_FAMILY {
  ASSURANCEVIE = 'ASSURANCEVIE',
  RETRAITE = 'RETRAITE',
  LIVRET = 'LIVRET',
  DEFISCALISATION = 'DEFISCALISATION',
  IMMOBILIER = 'IMMOBILIER',
}
